module.exports = __webpack_public_path__ + "static/media/27.e9108f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/27.png
// module id = 530
// module chunks = 0